import getTheme from 'config/themes/base';

const theme = getTheme();

export default {
  popoverBtn: {
    minHeight: '40px',
    color: theme.palette.primary.sideBarTextColor,
    opacity: '0.8',
    textTransform: 'capitalize',
  },
  popoverContainer: {
    backgroundColor: 'white',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '8px 8px 0 8px',
  },
  paper: {
    padding: '8px 0',
    borderRadius: '4px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.25)',
    minWidth: '250px',
  },
  customTextField: {
    marginTop: '16px',
    '& input::placeholder': {
      fontSize: '10px',
    },
    '& > label': {
      padding: '6px 16px 7px 16px',
      transform: 'translate(0, 1.5px) scale(1)',
      '&.MuiInputLabel-shrink': {
        transform: 'translate(0, -9px) scale(0.75)',
      },
    },
    '& > div': {
      '&:hover:not(.Mui-disabled):before': {
        borderBottomWidth: '1px',
      },
    },
    '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
      appearance: 'none',
    },
    '& > div:after': {
      borderBottomWidth: '1px',
    },
    '& > div > input': {
      padding: '3px 16px 7px 16px',
      fontWeight: 500,
      fontSize: '14px',
    },
  },
  primaryIconButton: {
    marginLeft: '16px',
  },
  capitalize: {
    textTransform: 'capitalize',
  },
  placeholder: {
    opacity: 0.5,
  },
  valueText: {
    margin: '8.82px 9px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    minWidth: '150px',
    maxWidth: '210px',
    fontSize: '14px',
    fontWeight: '500',
  },
  rangeInput: {
    borderRadius: '4px',
    border: '1px solid',
    borderColor: 'rgba(0, 0, 0, 0.2)',
    display: 'inline-flex',
    '&:hover': {
      cursor: 'pointer',
      borderColor: 'rgba(0, 0, 0)',
    },
  },
  arrowIcon: {
    paddingTop: '6px',
    width: '30px',
    '& > svg': {
      opacity: 0.6,
    },
  },
  colorizeSelected: {
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '& > div > input': {
      fontWeight: 500,
      fontSize: '14px',
      color: '#fff',
    },
    '& svg': {
      color: '#fff',
      opacity: 1,
    },
  },
  box: {
    minWidth: '200px',
    marginRight: '16px',
  },
  disabledBox: {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
    borderColor: 'rgba(0, 0, 0, 0.12)',
    cursor: 'default',
    '&:hover': 'none',
  },
  lockIcon: {
    display: 'flex',
    alignItems: 'center',
    paddingRight: '6px',
    cursor: 'pointer',
    '& > svg': {
      color: theme.palette.primary.sideBarIconColor,
      opacity: 0.8,
      padding: '5px',
      width: '0.7em',
      height: '0.7em',
      '&:hover': {
        backgroundColor: '#3d3d3d0c',
        borderRadius: '50%',
      },
    },
  },
  endAdornment: {
    display: 'flex',
    '& .MuiInputAdornment-root': {
      maxHeight: 'none',
    },
  },
  tooltip: {
    backgroundColor: 'white',
    color: 'black',
    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  },
  noAccess: {
    fontSize: '14px',
    color: theme.palette.primary.sideBarIconColor,
    textAlign: 'center',
    padding: '8px',
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: 'none',
  },
};
